<script>
export default {
  name: 'icon-stamp',
  props: {
    color: {
      type: String,
      default: '#00A5EE',
    },
  },
}
</script>

<template>
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M25.4688 18.6592H18.8944C17.1472 18.4688 16.632 15.5008 17.472 11.4352C17.976 8.9824 18.9952 7.0224 18.9952 4.9952C18.9952 2.24 16.7552 0 14 0C11.2448 0 9.00479 2.24 9.00479 4.9952C9.00479 7.0224 10.0128 8.9936 10.528 11.4352C11.368 15.5008 10.8528 18.4576 9.10561 18.6592H2.53119C1.13119 18.6592 0 19.7904 0 21.1904V27.2048H28V21.1904C28 19.7904 26.8688 18.6592 25.4688 18.6592Z"
      :fill="color"
    />
  </svg>
</template>
